import experimentMap from './experimentMap';

export const useExperiment = expId => {
    if (experimentMap[expId]) {
        return experimentMap[expId];
    }
    return experimentMap.defaultExpVariant;
};

